module.exports = __webpack_public_path__ + "static/media/thumbnail-interior.a8bf1f0a.jpeg";